import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import { type IconSize } from '@/components/SIcon.vue';
import type { SiffletColors } from '@/plugins/theme';

type Size = 'x-small' | 'small' | 'medium' | 'large' | 'x-large' | 'xx-large';
type Icon = string;

/**
 *
 * Display the rounded icon
 *
 */
export interface SRoundedProps {
  size?: Size
  backgroundColor?: SiffletColors
  borderColor?: SiffletColors
  color?: SiffletColors
  icon?: Icon
  text?: string | number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SRoundedIcon',
  props: {
  size: { default: 'medium' },
  backgroundColor: { default: 'bgTertiary' },
  borderColor: { default: 'borderPrimary' },
  color: { default: 'textPrimary' },
  icon: null,
  text: null
},
  setup(__props) {

const props = __props;


const SIZE_TO_DATA: Record<Size, { size: number, innerSize: number, iconSize: IconSize, textSize: string }> = ({
  'x-small': {
    size: 24, innerSize: 20, iconSize: 'small', textSize: '12px',
  },
  small: {
    size: 28, innerSize: 24, iconSize: 'small', textSize: '12px',
  },
  medium: {
    size: 32, innerSize: 28, iconSize: 'default', textSize: '14px',
  },
  large: {
    size: 40, innerSize: 36, iconSize: 'large', textSize: '18px',
  },
  'x-large': {
    size: 44, innerSize: 40, iconSize: 'large', textSize: '18px',
  },
  'xx-large': {
    size: 64, innerSize: 60, iconSize: 'x-large', textSize: '24px',
  },
});

const sizeInPixels = _computed(() => SIZE_TO_DATA[props.size].size);
const innerSizeInPixels = _computed(() => SIZE_TO_DATA[props.size].innerSize);
const iconSize = _computed(() => SIZE_TO_DATA[props.size].iconSize);
const textSize = _computed(() => SIZE_TO_DATA[props.size].textSize);
const innerStyle = _computed(() => ({
  height: `${innerSizeInPixels.value}px`,
  width: `${innerSizeInPixels.value}px`,
  backgroundColor: `var(--v-${props.backgroundColor}-base)`,
  borderColor: `var(--v-${props.borderColor}-base)`,
}));
const iconColor = _computed(() => `var(--v-${props.color}-base)`);
const textColor = _computed(() => `${props.color}--text`);

return { __sfc: true,props, SIZE_TO_DATA, sizeInPixels, innerSizeInPixels, iconSize, textSize, innerStyle, iconColor, textColor, _computed }
}

})